/**
 * utility functions to ease error handling
 */
/**
 * Attempt to extract an error message from an unknown type.
 * Will return messages for:
 *  - strings
 *  - Error objects or objects with Error as a parent
 *  - Objects that have a .message string property
 *  - Objects that have a custom .toString() implementation (ie, not '[object, Object])
 */
export function extractErrorMessage(e, defaultMessage) {
    if (typeof e === 'string') {
        return e;
    }
    if (typeof e !== 'object' || e === null) {
        return defaultMessage;
    }
    if (e instanceof Error || ('message' in e && typeof e.message === 'string')) {
        return e.message;
    }
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    const stringified = e.toString();
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    if (stringified !== {}.toString()) {
        // There is a custom toString for the object, let's use that
        return stringified;
    }
    return defaultMessage;
}
//# sourceMappingURL=errorHandling.js.map